<template>
    <CRow>
        <CCol>
            <CCard v-if="entity">
                <CCardHeader>
                    <strong>{{ entity.name }}</strong>
                </CCardHeader>
                <CCardBody>
                    <AdsCampaignTabLinks :campaignId="entity.id" />
                    <AdsCampaignCard :entity="entity" />
                </CCardBody>

                <CCardFooter>
                    <CButton color="primary" @click="$router.push('/ads-campaigns')">Назад</CButton>
                    <CButton
                        v-if="entity.id"
                        variant="outline"
                        color="danger"
                        class="ml-4"
                        @click="promptDelete"
                    >
                        Удалить
                    </CButton>
                </CCardFooter>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
import AdsCampaignTabLinks from '@/components/ads-campaigns/AdsCampaignTabLinks';
import AdsCampaignCard from '@/components/ads-campaigns/AdsCampaignCard';

export default {
    name: 'AdsCampaign',
    components: {
        AdsCampaignTabLinks,
        AdsCampaignCard,
    },
    data() {
        return {
            entity: null,
        };
    },
    async created() {
        await this.fetch();
    },
    methods: {
        async fetch() {
            const { id } = this.$route.params;
            try {
                const resp = await this.axios.get(`/ads-campaigns/${id}`);
                this.entity = resp.data;
            } catch (error) {
                console.log(error);
                this.$root.$emit('showError', 'Ошибка загрузки.');
            }
        },
        async promptDelete() {
            if (confirm('Вы уверены, что хотите удалить эту акцию?')) {
                try {
                    await this.axios.delete(`/ads-campaigns/${this.entity.id}`);
                    this.goBack();
                } catch (error) {
                    console.log(error);
                    this.$root.$emit('showError', 'Ошибка удаления.');
                }
            }
        },
        goBack() {
            this.$router.push({ path: `/ads-campaigns` });
        },
    },
};
</script>
